module.exports = __webpack_public_path__ + "static/media/plus_icon.a1410eb4.svg";